import { FormControl, FormLabel, FormErrorMessage, Input, InputRightElement, InputGroup, Box, Text } from "@chakra-ui/react";
import React from "react";
import NumberFormat from "react-number-format";
import { Phone } from "phosphor-react";
import { COLORS } from "../../../../Helper/Colors";

export const PhoneInput = ({
	label,
	placeholder,
	name,
	value,
	error,
	touched,
	handleChange,
	tooltip,
	isRequired = false,
	showTooltip = false,
	showIcon = true,
	inputBgColor = COLORS.light,
	...rest
}) => {
	return (
		<FormControl flex={1} isInvalid={!!error && touched}>
			<Box display={"flex"} flexDirection={"row"} alignItems={isRequired ? "start" : "center"}>
				<FormLabel htmlFor={rest.name} textTransform='capitalize' marginRight={0}>
					{label}
				</FormLabel>
				{!!isRequired && (
					<Text alignItems={"start"} marginLeft={1} color={COLORS.red}>
						*
					</Text>
				)}
			</Box>
			<InputGroup size={!!rest.size ? rest.size : "lg"}>
				<NumberFormat
					onValueChange={(val) => handleChange(name, val.value)}
					customInput={Input}
					type='text'
					name={name}
					id={name}
					displayType='input'
					value={value}
					placeholder={placeholder}
					format={"###-###-####"}
					className='custom-phone-input'
					{...rest}
				/>
				{showIcon && (
					<InputRightElement zIndex={0} marginTop={!!rest.size && "1"} children={<Phone size={24} color={COLORS.brand} />} />
				)}
			</InputGroup>
			<FormErrorMessage>{error}</FormErrorMessage>
		</FormControl>
	);
};
